import { StateController } from "@aceroll/core";

class RoundStartController extends StateController {
    constructor() {
        super("round.start");
    }
    onStart() {
        this.stop();
    }
    onStop() { }
}

export default RoundStartController;